import React from "react";
import { useParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import IdealCarousel from "../Components/MinComponents/IdealCarousel";

const Services=()=>{
    const {id}=useParams();
    const [image,setImage]=useState(null);
    const [image1,setImage1]=useState(null);
    //submitting the image
    const submitImage=async()=>{
        if(image==="" || image===null){
          alert("Insert an image");
          return;
        };
        const data = new FormData();
        data.append("file",image);
        data.append("upload_preset","custoshoe7")
        data.append("cloud_name","custoshoe7");
    
        await fetch(`${process.env.REACT_APP_CLOUDINARY_URL}`,
        {
          method:"POST",
          body:data
        })
        .then((res)=>res.json())
        .then((data)=>{
          setImage1(data.url);
          document.getElementById("large_size").value = "";
          setImage("");
        }).catch((err)=>{
          console.error('Error:', err);
        })
      }

      const handleSubmit = (event) => {
        event.preventDefault();
        if(image1===""||image===null){
            alert("Image not present");
            return;
        }
        const data={
          shippingInfo:{
            address:event.target[5].value,
            city:event.target[6].value,
            state:event.target[7].value,
            phoneNo:event.target[3].value,
            zip:event.target[9].value,
            country:event.target[8].value
          },
          Name:event.target[0].value+" "+event.target[1].value,
          phoneNo:event.target[3].value,
          email:event.target[2].value,
          orderItem:{
            name:id,
            image:image1
          },
          Price:event.target[4].value,
          }
          console.log(data);
          axios.post(`${process.env.REACT_APP_BASE}/order/new`, data)
        .then((response) => {
          console.log('Response:', response);
          document.getElementById("myForm").reset();
          setImage1(null);
          alert('Order Placed');
        
        })
        .catch((error) => {
          console.error('Error:', error);
          alert('Order not placed');
        });

      }
    return(
        <div className="p-10">
            <div className="text-2xl my-5 font-semibold">
            {
                id==="gifting"?"Gift a Shoe":
                id==="customization"?"Shoe Customization":
                id==="restoration"?"Shoe Restoration":
                id==="bridal"?"Make your Bridal Shoe":"Custom Form"
            } 
            </div>
            <form id="myForm" className="m-auto w-full max-w-lg border-black rounded-lg" onSubmit={handleSubmit}>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="firstname">
                    First Name
                  </label>
                  <input className="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="firstname" type="text" required/>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="lastname">
                    Last Name
                  </label>
                  <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="lastname" type="text" required/>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="email">
                    Email
                  </label>
                  <input className="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="email" type="email" required/>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="phone">
                    Phone Number
                  </label>
                  <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="phone" type="number" required/>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-full px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="price">
                    Budget
                  </label>
                  <input className="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="price" type="Number" required/>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-full px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="address">
                    Address
                  </label>
                  <input className="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="address" type="text" required/>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="city">
                    City
                  </label>
                  <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="city" type="text" required/>
                </div>
                
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                    State
                  </label>
                  <div className="relative">
                    <select name="state" className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="state" required>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                        <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                        <option value="Assam">Assam</option>
                        <option value="Bihar">Bihar</option>
                        <option value="Chandigarh">Chandigarh</option>
                        <option value="Chhattisgarh">Chhattisgarh</option>
                        <option value="Dadar and Nagar Haveli">Dadar and Nagar Haveli</option>
                        <option value="Daman and Diu">Daman and Diu</option>
                        <option value="Delhi">Delhi</option>
                        <option value="Lakshadweep">Lakshadweep</option>
                        <option value="Puducherry">Puducherry</option>
                        <option value="Goa">Goa</option>
                        <option value="Gujarat">Gujarat</option>
                        <option value="Haryana">Haryana</option>
                        <option value="Himachal Pradesh">Himachal Pradesh</option>
                        <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                        <option value="Jharkhand">Jharkhand</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="Kerala">Kerala</option>
                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Manipur">Manipur</option>
                        <option value="Meghalaya">Meghalaya</option>
                        <option value="Mizoram">Mizoram</option>
                        <option value="Nagaland">Nagaland</option>
                        <option value="Odisha">Odisha</option>
                        <option value="Punjab">Punjab</option>
                        <option value="Rajasthan">Rajasthan</option>
                        <option value="Sikkim">Sikkim</option>
                        <option value="Tamil Nadu">Tamil Nadu</option>
                        <option value="Telangana">Telangana</option>
                        <option value="Tripura">Tripura</option>
                        <option value="Uttar Pradesh">Uttar Pradesh</option>
                        <option value="Uttarakhand">Uttarakhand</option>
                        <option value="West Bengal">West Bengal</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
                </div>

                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                    Country
                  </label>
                  <div className="relative">
                    <select className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="state" required>
                      <option default disabled>Country</option>
                      <option>India</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mx-auto md:w-1/2">
                <div className="w-full ">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-zip">
                        Zip
                    </label>
                    <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-zip" type="text" placeholder="90210" required/>
                </div>
              </div>
              <label className="block mb-2 text-sm font-medium text-black" for="large_size">Upload Image here</label>
                <div className="grid grid-cols-2">
                    <input className="block w-full text-lg text-gray-900 border border-gray-300 rounded-sm cursor-pointer bg-gray-50 focus:outline-black" id="large_size" type="file" onChange={(e)=>{setImage(e.target.files[0])}}/>
                    <div className="block w-1/2 mx-auto text-lg text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none text-center align-center" onClick={submitImage}>Upload</div>
                </div>                
                {
                image1
                   && 
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                     Uploaded Images
                    </label>
                      <img src={`${image1}`} alt="" />
                </div>
                }
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 my-5 rounded">Submit</button>
            </form>
            <h1>
                Some of our works
            </h1>
            <IdealCarousel/>
        </div>        
    )
}
export default Services;
